import React, { useEffect } from 'react';
import { Select } from 'antd';
import GetVatMerchants from '../../functions/reference/vatMerchant';


const { Option } = Select;

const VatMerchantSelect = ({ onChange, value }) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const merchantId=localStorage.getItem('merchantId')
    useEffect(() => {
         fetchList()
    },[])
    const fetchList = async () => {
         setLoading(true)
         const response=await GetVatMerchants(merchantId)
         if(response){
           var data=response.map(e=>({id:e.register,name:e.name}))
           if(true)// add extra select option
              data=[{id:null,name:'сонго'},...data] 
           setData(data)
           if(value==null) onChange(data[0].id)
        }
    }
    return (
        <Select
            placeholder="Select a product type"
            onChange={onChange}
            value={value}
            loading={loading}
            style={{ width: '100%' }}
        >
            {data.map((item) => (
                <Option key={item.id} value={item.id}>
                    {item.name}
                </Option>
            ))}
        </Select>
    );
};

export default VatMerchantSelect;